// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1dXUV","col":"CardReaderDesc_col__8TgI7","label":"CardReaderDesc_label__rNBjZ"};